import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const SporToto = loadable(() => pMinDelay(import('./SporToto'), 300), {
  fallback: <Loading />
});

const AsyncSporToto = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <SporToto { ...props }/>
    </ApplicationLayout>
  );
};

AsyncSporToto.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncSporToto;
